import React from 'react';
import Modal from 'app/blocks/Modal/Modal';
import { Button, PrimaryButton } from 'app/blocks/buttons/buttons';
import './ConfirmCopyrightModal.scss';

type Props = {
    title: string;
    message: string;
    cancelBtnLabel: string;
    confirmBtnLabel: string;
    onApprove: () => void;
    onReject: () => void;
};

function ConfirmCopyrightModal({
    title,
    message,
    cancelBtnLabel,
    confirmBtnLabel,
    onApprove,
    onReject
}) {
    return (
        <Modal className="ConfirmCopyrightModal" onClose={onReject} type="confirmation">
            <div 
                className="ConfirmCopyrightModal-Body"
                data-seleniumid="ConfirmCopyrightModal-body"
            >
                <div 
                    className="ConfirmCopyrightModal-Title"
                    data-seleniumid="ConfirmCopyrightModal-title"
                >
                    {title}
                </div>
                <div
                    className="ConfirmCopyrightModal-Message"
                    data-seleniumid="confirmation-message"
                    dangerouslySetInnerHTML={{ __html: message }}
                />
                <div className="ConfirmCopyrightModal-Actions">
                    <PrimaryButton
                        className="ConfirmCopyrightModal-Confirm"
                        data-seleniumid="confirmation-dialog-confirm-button"
                        onClick={onApprove}
                        type="button"
                    >
                        {confirmBtnLabel}
                    </PrimaryButton>
                    <Button
                        className="ConfirmCopyrightModal-Cancel"
                        data-seleniumid="confirmation-dialog-cancel-button"
                        onClick={onReject}
                        type="button"
                    >
                        {cancelBtnLabel}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default ConfirmCopyrightModal;